import React from 'react'
import Header from './Header'
import Footer from './Footer'
import { useNavigate } from 'react-router-dom'
import MenuSidebar from './MenuSidebar'

const DepositNew = () => {
  const navigate = useNavigate()
  return (
    <div className='t1'>
      <div className='page'>
        <div className="page-content footer-clear">
          <Header />
          <div id="deposit_cards">
            <div>
              <a onClick={e => {
                e.preventDefault()
                navigate("/manual-transfer")
              }} className="pay_menu">
                <img src={require("../../src/image/auto-ewallet.jpg")} alt="" />
              </a>
              <a onClick={e => {
                e.preventDefault()
                navigate("/online-transfer")
              }} className="pay_menu">
                <img src={require("../../src/image/online.jpg")} alt="" />
              </a>
              <a onClick={e => {
                e.preventDefault()
                navigate("/ewallet-transfer")
              }} className="pay_menu">
                <img src={require("../../src/image/ATM.jpg")} alt="" />
              </a>
            </div>
          </div>
        </div>
        <Footer />
        <MenuSidebar />
      </div>
    </div>
  )
}

export default DepositNew